import React, { useContext } from 'react';
import { Link, ScrollRestoration, useLoaderData } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import { Footer, AppHeader } from './template';
import * as Product from './product';
import * as Algolia from './algolia';
import {
  Configure,
  RefinementList,
  Highlight,
  ClearRefinements,
  useStats,
  Hits,
  InstantSearch,
  SearchBox,
  useInstantSearch,
} from 'react-instantsearch';


export async function loader({ params }) {

  return await Algolia.misc.getObject( //TODO handle failure
    'most-reduced'
  );
}

const mostReducedBreadcrumb = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Αρχική", "item": "https://www.zuper-market.gr/" },
    { "@type": "ListItem", "position": 2, "name": "Μεγάλες πτώσεις τιμών", "item": "https://www.zuper-market.gr/most-reduced" }
  ]
};

function buildItemList(items, name) {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": name,
    "numberOfItems": items.length,
    "itemListElement": items.map((item, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "url": `https://www.zuper-market.gr${Product.internalURL(item)}`,
      "name": item.title
    }))
  };
}

export function MostReducedPage() {
  const mostReduced = useLoaderData();

  const relList = buildItemList(mostReduced['most-reduced'].rel, 'Μεγάλες πτώσεις τιμών — ποσοστιαία');
  const absList = buildItemList(mostReduced['most-reduced'].abs, 'Μεγάλες πτώσεις τιμών — απόλυτη');

  return (
    <div>
      <Helmet>
        <title>Μεγάλες πτώσεις τιμών σε σούπερ μάρκετ — εβδομαδιαία λίστα | zuper</title>
        <meta name="description" content="Τα προϊόντα με τις μεγαλύτερες πτώσεις τιμών αυτή την εβδομάδα σε ΑΒ, Σκλαβενίτη, Lidl, Μασούτη και άλλα σούπερ μάρκετ. Ποσοστιαία & απόλυτη μείωση, ενημέρωση κάθε λίγες ώρες." />
        <link rel="canonical" href="https://www.zuper-market.gr/most-reduced" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.zuper-market.gr/most-reduced" />
        <meta property="og:title" content="Μεγάλες πτώσεις τιμών στα σούπερ μάρκετ" />
        <meta property="og:description" content="Τα προϊόντα με τις μεγαλύτερες πτώσεις τιμών σε 13 αλυσίδες σούπερ μάρκετ. Ενημέρωση κάθε λίγες ώρες." />
        <script type="application/ld+json">{JSON.stringify(mostReducedBreadcrumb)}</script>
        <script type="application/ld+json">{JSON.stringify(relList)}</script>
        <script type="application/ld+json">{JSON.stringify(absList)}</script>
      </Helmet>

      {/* Desktop logo - above AppHeader */}
      <div className='hidden lg:block mx-auto py-4 text-center text-4xl text-lime-600 font-extrabold tracking-wide'>
        <h1><Link to="/">zuper</Link></h1>
      </div>
      
      <AppHeader />
      
      <div className='max-w-6xl mx-auto p-8'>

      <h2 className='text-2xl pt-2 pb-4'>Μεγάλες πτώσεις τιμών</h2>

      <p className='text-gray-600 text-sm'>Ανανεώθηκε πριν {Product.formatDuration((Date.now() - mostReduced['as-of']) / 1000)}</p>

      <h3 className='text-xl pt-2 pb-4'>Ποσοστιαία</h3>

      <div className="ais-Hits">
        {/* Desktop view */}
        <div className="hidden sm:block">
          <div className="ais-Hits-list grid lg:grid-cols-5 md:grid-cols-4 sm:grid-cols-4 grid-cols-1">
            {
              mostReduced['most-reduced'].rel.map((item, index) => (
                <div className="ais-Hits-item m-1" key={item.id}>
                  <Product.DesktopHit hit={item} useHighlight={false} />
                </div>
              ))
            }
          </div>
        </div>
        
        {/* Mobile view */}
        <div className="sm:hidden block">
          <div className="ais-Hits-list grid grid-cols-1 divide-y">
            {
              mostReduced['most-reduced'].rel.map((item, index) => (
                <div className="ais-Hits-item" key={item.id}>
                  <Product.MobileHit hit={item} useHighlight={false} />
                </div>
              ))
            }
          </div>
        </div>
      </div>

      <h3 className='text-xl pt-24 pb-4'>Απόλυτη τιμή</h3>

      <div className="ais-Hits">
        {/* Desktop view */}
        <div className="hidden sm:block">
          <div className="ais-Hits-list grid lg:grid-cols-5 md:grid-cols-4 sm:grid-cols-4 grid-cols-1">
            {
              mostReduced['most-reduced'].abs.map((item, index) => (
                <div className="ais-Hits-item m-1" key={item.id}>
                  <Product.DesktopHit hit={item} useHighlight={false} />
                </div>
              ))
            }
          </div>
        </div>
        
        {/* Mobile view */}
        <div className="sm:hidden block">
          <div className="ais-Hits-list grid grid-cols-1 divide-y">
            {
              mostReduced['most-reduced'].abs.map((item, index) => (
                <div className="ais-Hits-item" key={item.id}>
                  <Product.MobileHit hit={item} useHighlight={false} />
                </div>
              ))
            }
          </div>
        </div>
      </div>

        <div className="pt-32">
          <Footer />
        </div>
      </div>
      <ScrollRestoration />
    </div>
  );
}
